export const __actionTypes = {
  SET_TO_REFRESH: "[SET_TO_REFRESH] Action",
  RESET_REFRESH_STATE: "[RESET_REFRESH_STATE] Action",
};

const __initialState = false;

export const reducer = (state = __initialState, action) => {
  switch (action.type) {
    case __actionTypes.SET_TO_REFRESH: {
      return true;
    }

    case __actionTypes.RESET_REFRESH_STATE: {
      return __initialState;
    }

    default:
      return state;
  }
};

export const RefreshDataActions = {
  SET_TO_REFRESH: () => ({ type: __actionTypes.SET_TO_REFRESH }),
  RESET_REFRESH_STATE: () => ({ type: __actionTypes.RESET_REFRESH_STATE }),
};
